import { FIRST_VISIT_URL_NAME } from '@loc/helpers/src/index'

import { useCookieDomain } from './cookieDomain'
import { useMountIdle } from './idle'

import { getCookies, setCookie } from '@/helpers/cookies.browser'
/** 用户首次访问的 url */
/** 标记是否测试环境用户 */
export const TEST_ENV_VISITORS_NAME = 'test-env-visitors'

const oneDayMilliseconds = 24 * 60 * 60 * 1000

/** 设置站点级 cookie */
export function useBaseCookies() {
  const { cookieDomain, cookieDomainRef } = useCookieDomain()

  useMountIdle(() => {
    const cookies = getCookies()
    if (!cookies[FIRST_VISIT_URL_NAME]) {
      const pageUrl = window.decodeURIComponent(window.location.href)
      setCookie(FIRST_VISIT_URL_NAME, pageUrl, {
        domain: cookieDomainRef.current,
        path: '/',
        expires: new Date(Date.now() + oneDayMilliseconds * 100),
      })
    }
  })

  useMountIdle(() => {
    if (process.env.NEXT_PUBLIC_APP_ENV === 'test') {
      const cookies = getCookies()
      const textEnvVisitors = cookies[TEST_ENV_VISITORS_NAME]
      if (!textEnvVisitors) {
        setCookie(TEST_ENV_VISITORS_NAME, '1', {
          domain: cookieDomainRef.current,
          path: '/',
          expires: new Date(Date.now() + oneDayMilliseconds * 100),
        })
      }
    }
  })
}
